import { FileText as Description, X as Close } from "lucide-react";

export const FilePreview = ({
  filename,
  handleOnDelete,
  locked,
  onClick,
}: {
  filename: string;
  handleOnDelete: any;
  locked?: boolean;
  onClick?: () => void;
}) => {
  return (
    <section
      className={`border-none bg-muted/50 p-2 px-3 text-center flex items-center rounded-md border w-full justify-between ${onClick ? "cursor-pointer hover:bg-muted/80 transition-colors" : ""}`}
      onClick={onClick}
    >
      <div className="flex gap-2 items-center align-middle">
        <Description className="text-muted-foreground h-4 w-4" />
        <span className="underline">{filename}</span>
      </div>
      <div>
        <button
          className="rounded-full  text-xs  content-[''] leading-none grid place-items-center top-2 end-2 cursor-pointer border-[#d4d4d4]"
          onClick={(e) => {
            e.stopPropagation();
            if (handleOnDelete) handleOnDelete(e);
          }}
        >
          {locked ? null : (
            <Close
              style={{ height: "24px", width: "24px", color: "#d4d4d4" }}
            />
          )}
        </button>
      </div>
    </section>
  );
};

export const FileItem = ({
  filename,
  handleDelete,
  onClick,
}: {
  filename: string;
  handleDelete?: (id: string, category: string) => void;
  onClick?: () => void;
}) => {
  return (
    <FilePreview
      handleOnDelete={handleDelete}
      filename={filename}
      locked={!handleDelete}
      onClick={onClick}
    />
  );
};
